import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase'
@Injectable({
  providedIn: 'root'
})
export class UserserviceService {

  constructor(private afAuth: AngularFireAuth, private afs: AngularFirestore) { }


  checkUserEmail(email, password ) {


    const credentials = firebase.auth.EmailAuthProvider.credential(email, password);

   return this.afAuth.auth.currentUser.reauthenticateWithCredential(credentials).then(d => {
      //console.log(d)
    }).catch(err => {
      console.log(`Error: ${err}`)
    })
  }

  updatePassword(password) {
   return this.afAuth.auth.currentUser.updatePassword(password)
  }

  getCurrentModules() {
    return new Promise<any>((resolve, reject) => {
      this.afs.collection('devices').ref.where('parent', '==', this.afAuth.auth.currentUser.uid).get().then(d => {
        let data = d.docs.map(v => v.data().modules)
       // console.log(data);

        let modules = {};
        data.forEach(item => {
          for (const key in item) {
            if (!modules[key]) {
              modules[key] = item[key]
            }
            else if (modules[key] && item[key] == true) {
              modules[key] = true;
            }
        //    console.log(`${key}: ${item[key]}`);
          }

 

        })

        resolve(modules);
  //      console.log(modules);

      })
    })

  }

}
